<template>
<div class="container pb-5 userAccountCont">
    <div class="row">
        <div class="col-12">
            <h2 class="text-center mb-5">Personal Information</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-6">
            <div class="card">
                <div class="card-body">
                    <h3 class="cardTitle textLightGray mb-5">General Info</h3>

                    <form class="text-left" @submit.prevent="updateInfo()">
                        <label class="inputWrpr"
                            :class="{ 'error': form.errors.has('first_name') ,'haveValue': form.first_name }">
                            <input type="text" class="form-control" v-model="form.first_name">
                            <span class="label">First Name</span>
                            <has-error :form="form" field="first_name" class="errormsg"></has-error>
                        </label>
                        <label class="inputWrpr"
                            :class="{ 'error': form.errors.has('last_name') ,'haveValue': form.last_name }">
                            <input type="text" class="form-control" v-model="form.last_name">
                            <span class="label">Last Name</span>
                            <has-error :form="form" field="last_name" class="errormsg"></has-error>
                        </label>
                        <label class="inputWrpr"
                            :class="{ 'error': form.errors.has('email') ,'haveValue': form.email }">
                            <input type="email" class="form-control" v-model="form.email">
                            <span class="label">Email</span>
                            <has-error :form="form" field="email" class="errormsg"></has-error>
                        </label>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-3">

                                    <label class="inputWrpr"  :class="{ 'error': form.errors.has('country_code') ,'haveValue': form.country_code }">
                                        <div class="form-control select">{{form.country_code}}</div>
                                        <span class="label w-100"></span>
                                        <div class="selectDropDown">
                                            <CountryList  @clicked="onCountryChange"/>
                                        </div>
                                        <has-error :form="form" field="country_code" class="errormsg"></has-error>
                                    </label>
                                </div>
                                <div class="col-9">
                                    <label class="inputWrpr"
                                        :class="{ 'error': form.errors.has('phone_number') ,'haveValue': form.phone_number }">
                                        <input type="tel" class="form-control" v-model="form.phone_number">
                                        <span class="label">Phone Number</span>
                                        <has-error :form="form" field="phone_number" class="errormsg"></has-error>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center">
                            <button type="submit" class="btnSucces">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="card">
                <div class="card-body">
                    <h3 class="cardTitle textLightGray mb-5">Shipping Address Info</h3>
                    <form class="text-left" @submit.prevent="updateInfo('shipping')">
                        <label class="inputWrpr" :class="{ 'error': shipping_address.errors.has('street') ,'haveValue': shipping_address.street }">
                            <input type="text" v-model="shipping_address.street" class="form-control">
                            <span class="label">Street</span>
                            <has-error :form="shipping_address" field="street" class="errormsg"></has-error>
                        </label>
                        <label class="inputWrpr" :class="{ 'error': shipping_address.errors.has('city') ,'haveValue': shipping_address.city }">
                            <input ype="text" v-model="shipping_address.city" class="form-control">
                            <span class="label">City</span>
                            <has-error :form="shipping_address" field="city" class="errormsg"></has-error>
                        </label>
                        <label class="inputWrpr" :class="{ 'error': shipping_address.errors.has('state') ,'haveValue': shipping_address.state }">
                            <input type="text" v-model="shipping_address.state" class="form-control">
                            <span class="label">State</span>
                            <has-error :form="shipping_address" field="state" class="errormsg"></has-error>
                        </label>
                        <label class="inputWrpr" :class="{ 'error': shipping_address.errors.has('zip_code') ,'haveValue': shipping_address.zip_code }">
                            <input type="text" v-model="shipping_address.zip_code" class="form-control">
                            <span class="label">Zip Code</span>
                            <has-error :form="shipping_address" field="zip_code" class="errormsg"></has-error>
                        </label>
                        <label class="inputWrpr" :class="{ 'error': shipping_address.errors.has('apartment') ,'haveValue': shipping_address.apartment }">
                            <input type="text" v-model="shipping_address.apartment" class="form-control">
                            <span class="label">Apartment</span>
                            <has-error :form="shipping_address" field="apartment" class="errormsg"></has-error>
                        </label>
                        <div class="form-group text-center">
                            <button type="submit" class="btnSucces">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
 import CountryList from '../../Country-list.vue'
 import {
     mapGetters,
     mapActions
 } from "vuex";
 export default {
     name: "User-info",
     props: ['filtertab'],
     components: {
         CountryList
     },
     data() {
         return {
             form: new Form({
                 id: '',
                 first_name: '',
                 last_name: '',
                 email: '',
                 country_code: '',
                 phone_number: '',
                 upfor: 'info',
             }),
             shipping_address: new Form({
                 upfor: 'shipping',
                 street: '',
                 city: '',
                 state: '',
                 zip_code: '',
                 apartment: '',
             })
         }
     },
     computed: {
         ...mapGetters(["errors"]),
     },
     mounted() {
         this.$store.commit("setErrors", {});
     },
     created() {


     },
     watch: {
         async filtertab(n, o) {
             if (n == 'Information') {

                 axios.get("api/profile")
                     .then(({
                         data
                     }) => {
                         let fdata = data.data
                         fdata.upfor = 'info'
                         this.form.fill(fdata)
                         if (fdata.shipping_address) {
                             fdata.shipping_address.upfor = 'shipping'
                             this.shipping_address.fill(fdata.shipping_address)
                         }
                     });
             }
         },
     },
     methods: {
         onCountryChange(value) {
             this.form.country_code = value;
         },
         updateInfo(n) {
             if (n == 'shipping') {
                 this.shipping_address.put('api/profile')
                     .then((data) => {
                         let fdata = data.data.data
                         fdata.upfor = 'shipping'
                         this.shipping_address.fill(fdata)
                         Toast.fire({
                             icon: 'success',
                             title: data.data.message
                         });
                     })
                     .catch((data) => {

                     });
             } else {

                 this.form.put('api/profile')
                     .then((data) => {
                         let fdata = data.data.data
                         fdata.upfor = 'info'
                         this.form.fill(fdata)
                         this.$root.$emit('get_profile', '');
                         Toast.fire({
                             icon: 'success',
                             title: data.data.message
                         });
                     })
                     .catch((data) => {

                     });
             }
         },
     }
 }
    </script>
